var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine6Cup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 34,
    viewBox: "0 0 43 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8947_271010",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 33,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.232 13.665L26.0218 15.6648H32.0542H32.5422L31.5467 26.5827C31.3237 29.0286 31.2122 30.2515 30.649 31.1857C30.1537 32.0074 29.4219 32.6755 28.5586 33.0942C27.5771 33.5702 26.3491 33.5702 23.8931 33.5702H7.22901C4.77302 33.5702 3.54502 33.5702 2.65036 33.0942C1.86339 32.6755 1.25345 32.0074 0.907944 31.1857C0.515158 30.2515 0.626668 29.0286 0.849688 26.5827L2.36289 9.98747C2.58591 7.54163 2.69742 6.31871 3.26057 5.38452C3.75594 4.56278 4.48772 3.89469 5.35104 3.47599C6.33251 3 7.5605 3 10.0165 3H25.7084L31.4844 8.33221L31.2041 10.9986L26.232 13.665Z",
    fill: "#E73C27"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8947_271010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3404 9.87651C2.56342 7.43067 2.67493 6.20774 3.23808 5.27355C3.73344 4.45182 4.46522 3.78373 5.32855 3.36503C6.31001 2.88904 7.53801 2.88904 9.994 2.88904H26.6581C29.1141 2.88904 30.3421 2.88904 31.2367 3.36503C32.0237 3.78373 32.6337 4.45182 32.9792 5.27355C33.3719 6.20774 33.2604 7.43067 33.0374 9.87651L31.5242 26.4718C31.3012 28.9176 31.1897 30.1405 30.6265 31.0747C30.1312 31.8965 29.3994 32.5645 28.5361 32.9832C27.5546 33.4592 26.3266 33.4592 23.8706 33.4592H7.20651C4.75052 33.4592 3.52253 33.4592 2.62786 32.9832C1.8409 32.5645 1.23095 31.8965 0.885449 31.0747C0.492663 30.1405 0.604173 28.9176 0.827193 26.4718L2.3404 9.87651Z",
    fill: "#39ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5887 25.651C13.6677 25.651 12.6557 23.857 12.9547 21.258L13.7367 13.668C13.9897 11.207 15.2087 9.68898 17.8307 9.68898C20.5907 9.68898 21.4647 11.23 21.2117 13.53L21.1197 14.427H18.7277L18.8197 13.553C18.9347 12.472 18.6817 11.874 17.6927 11.874C16.7727 11.874 16.4737 12.541 16.3587 13.484L16.0137 16.842H16.0367C16.4737 16.106 17.2097 15.577 18.2217 15.577C20.2227 15.577 21.0737 16.934 20.7977 19.671L20.5677 21.948C20.3147 24.363 19.0957 25.651 16.5887 25.651ZM16.5887 23.512C17.4857 23.512 17.8767 22.937 17.9687 21.948L18.2447 19.234C18.3367 18.222 18.0147 17.67 17.1177 17.67C16.3127 17.67 15.8757 18.153 15.7837 19.096L15.4847 21.948C15.3697 22.983 15.7377 23.512 16.5887 23.512Z",
    fill: "#091020"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8081 13.0655L29.9553 11.6656L33.4358 9.79908L33.632 7.93258L28.0719 2.79969L28.2681 0.93319H31.0833L31.1814 -6.10352e-05H35.4041H39.6269L39.5288 0.93319H42.3439L42.1478 2.79969L35.5088 7.93258L35.3126 9.79908L38.4008 11.6656L38.2536 13.0655H34.0309H29.8081ZM31.4544 1.86644H29.5776L29.5286 2.33307L31.2582 3.73294L31.4544 1.86644ZM38.9615 1.86644H40.8383L40.7892 2.33307L38.7653 3.73294L38.9615 1.86644Z",
    fill: "#FFB800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine6Cup1);
export default __webpack_public_path__ + "static/media/line-6-cup-1.0d9133a208aa00fafd569f7a534baba3.svg";
export { ForwardRef as ReactComponent };